import { Component } from 'react';
import Raven from 'raven-js';
export class PluginErrorBoundary extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(error, info) {
    Raven.captureException(new Error('PluginErrorBoundary caught', {
      cause: error
    }), {
      fingerprint: ['PLUGIN_ERROR_BOUNDARY'],
      tags: {
        library_name: 'breeze-artifacts-sdk'
      },
      extra: {
        componentStack: info.componentStack
      }
    });
  }
  render() {
    return this.state.hasError ? this.props.fallback : this.props.children;
  }
}